import { 
    CONTACT_ACTIVITY_DATA_FAIL, 
    CONTACT_ACTIVITY_DATA_REQUEST, 
    CONTACT_ACTIVITY_DATA_SUCCESS 
} from "../constants/contactConstants";

export const contactActivityReducer = (state = { activityRec: '' }, action) => {
    switch (action.type) {
        case CONTACT_ACTIVITY_DATA_REQUEST:
            return { loading: true };
        case CONTACT_ACTIVITY_DATA_SUCCESS:
            return { loading: false, activityRec: action.payload }
        case CONTACT_ACTIVITY_DATA_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}
